import { IsString } from 'class-validator';

export class TaxonomyReferenceGetRequest {
    @IsString()
    public uuid: string;

    constructor(data?: Partial<TaxonomyReferenceGetRequest>) {
        this.uuid = data && data.uuid;
    }
}
